/* Cierre de post-t7-1, Bloque D (#605): los textos y las piezas puras de la página
   del registro de errores del admin. Sólo español (la página es sólo del admin); los
   rótulos son los del Anexo E.3 del encargo. La clase y la frase de cada renglón las
   decide el servidor; aquí sólo cómo se pintan. */

export const TEXTOS_REGISTRO = {
  titulo: 'Registro de errores',
  exportar: 'Exportar',
  actualizar: 'Actualizar',
  borrar_todo: 'Borrar todo',
  buscar: 'Buscar por correo',
  buscando: 'buscando',
  nada_coincide: 'Nada coincide.',
  nada_aqui: 'Nada aquí.',
  mensaje: 'Mensaje completo',
  usuario: 'Usuario',
  documento: 'Documento',
  detalles: 'Detalles',
  cuando: 'Cuándo',
  compra_de: 'compra de',
  confirmar_borrar: '¿Borrar todo el registro de errores?',
  borrado: 'Se borró el registro.',
  no_borro: 'No se pudo borrar.',
  exportado: 'Se exportó el registro.',
  no_exporto: 'No se pudo exportar.',
  no_cargo: 'No se pudo cargar el registro.',
  total: (n) => (Number(n) === 1 ? '1 registro en total' : `${Number(n || 0).toLocaleString('es-MX')} registros en total`),
};

export const PESTANAS = [
  { clave: 'falla', rotulo: 'Fallas' },
  { clave: 'aviso', rotulo: 'Avisos' },
  { clave: 'evento', rotulo: 'Eventos' },
  { clave: 'todo', rotulo: 'Todo' },
];

const NOMBRES = { falla: 'Falla', aviso: 'Aviso', evento: 'Evento' };

export function nombreDeClase(clase) {
  return NOMBRES[clase] || NOMBRES.falla;
}

/* El color va por CLASE (rojo, ámbar y azul), no por una subcadena del tipo. */
const COLORES = {
  falla: 'bg-red-500/15 text-red-400 border-red-500/20',
  aviso: 'bg-amber-500/15 text-amber-400 border-amber-500/20',
  evento: 'bg-blue-500/15 text-blue-400 border-blue-500/20',
};

export function colorDeClase(clase) {
  return COLORES[clase] || COLORES.falla;
}

/* La hora de México, siempre (el panel lo lee Carlos, sin importar dónde esté la máquina). */
export function cuandoEnMexico(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  try {
    return d.toLocaleString('es-MX', {
      timeZone: 'America/Mexico_City', day: 'numeric', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: false,
    });
  } catch {
    return d.toISOString();
  }
}
